var app = angular.module("leonardo");

var OnDemandInstructionsUnread = function($scope, $state, $filter, $stateParams, OnDemandCategoryService,
                                          OnDemandInstructionService) {
  $scope.item = null;
  $scope.list_left = [];
  $scope.list_right = [];

  OnDemandCategoryService.get($stateParams.pk).then(function(item) {
    $scope.category = item;
  });

  OnDemandInstructionService.unread({category: $stateParams.pk}).then(function(list){
    var results = list.results ? list.results : list;
    $scope.init_cols(results);
    $scope.listInitial = results;
  });

  $scope.init_cols = function(list) {
    $scope.list_left = [];
    $scope.list_right = [];
    list = $filter('orderBy')(list, 'name')
    angular.forEach(list, function(value, key){
      if (key < list.length/2) {
        $scope.list_left.push(value);
      }
      else {
        $scope.list_right.push(value);
      }
    });
  };

  $scope.doFilter = function() {
    if ($scope.filter.length == 0) {
      $scope.init_cols($scope.listInitial);
      return;
    }
    $scope.init_cols($filter('onDemandInstructionsFilter')($scope.listInitial, $scope.filter));
  };

  $scope.goToForm = function(item) {
    $state.go('on-demand-instructions.instruction-edit', {pk: item.id});
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.instruction', {pk: item.id});
  };

};

app.controller('OnDemandInstructionsUnread', ['$scope', '$state', '$filter', '$stateParams', 'OnDemandCategoryService',
  'OnDemandInstructionService', OnDemandInstructionsUnread]);
